import { StyleSheet } from 'react-native';
import { colors } from '../../shared/theme/colors'
import { spacing } from '../../shared/theme/spacing'
import { typography } from '../../shared/theme/typography';

export const styles = StyleSheet.create({
  checkoutFiscalSwitchRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.md,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    minHeight: 56,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: colors.border,
    backgroundColor: colors.inputBackground,
  },
  checkoutFiscalSwitchLeading: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    minWidth: 0,
  },
  checkoutFiscalSwitchText: {
    flex: 1,
    gap: 2,
    minWidth: 0,
  },
  checkoutFiscalSwitchTitle: {
    ...typography.body,
    fontSize: 15,
    fontWeight: '600',
    color: colors.textPrimary,
  },
  checkoutFiscalSwitchHint: {
    ...typography.caption,
    fontSize: 12,
    lineHeight: 16,
    color: colors.textSecondary,
  },
  checkoutFiscalBuyerBlock: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: spacing.sm,
  },
  checkoutFiscalBuyerCfRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  fiscalFieldLabel: {
    ...typography.caption,
    color: colors.textSecondary,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
});
